var React = require('react');

function AngleDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M28.6782 1.85977C29.8486 3.03256 29.8486 4.93404 28.6782 6.10683L17.1191 17.6901C15.9488 18.8629 14.0512 18.8629 12.8809 17.6901L1.32176 6.10684C0.15141 4.93404 0.151409 3.03257 1.32176 1.85977C2.49211 0.686976 4.38962 0.686976 5.55997 1.85977L15 11.3195L24.44 1.85977C25.6104 0.686972 27.5079 0.686971 28.6782 1.85977Z","fill":"black"}));
}

AngleDownIcon.defaultProps = {"width":"30","height":"19","viewBox":"0 0 30 19","fill":"none"};

module.exports = AngleDownIcon;

AngleDownIcon.default = AngleDownIcon;
